import { AppColors } from '../../../StyledComponents/Graphics';
import styled from 'styled-components';


const StockChartContainer = styled.div`
	background: #0a1926;
    width:${({ width }) => (width)}px;
    height: 100%;
`;

const StockSelect = styled.select`
	background-color: ${AppColors.MRNAVY15};
	color: ${AppColors.MRLITE90};
	border: 1px solid ${AppColors.MRNAVY60};
	z-index: 999;
	margin: 0 5px;
	padding: 5px;
	height: 44px;
`;

const TickerInfo = styled.div`
	display: flex;
	flex-direction: column;
	margin: 0 10px;
    position: relative;
    cursor: ${({ onClick }) => onClick ? 'pointer' : 'default'};


	h1 {
		font-size: 16px;
		line-height: 28px;
		margin: 0;
	}

	h2 {
		font-size: 12px;
		margin: 0;
	}

	@media (max-width: 768px) {
		margin: 0;
	}
`;

const FilterContainer = styled.div`
	position: absolute;
	top: calc(100% + 8px);
	right: 0;
	background: linear-gradient(135deg, #0f2537 0%, #0a1926 100%);
	padding: 24px;
	border-radius: 12px;
	border: 1px solid rgba(93, 211, 158, 0.2);
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.05);
	z-index: 1000;
	min-width: 700px;
	animation: slideDown 0.2s ease-out;
	backdrop-filter: blur(10px);

	@keyframes slideDown {
		from {
			opacity: 0;
			transform: translateY(-10px);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	&::before {
		content: '';
		position: absolute;
		top: -6px;
		right: 20px;
		width: 12px;
		height: 12px;
		background: #0f2537;
		border-left: 1px solid rgba(93, 211, 158, 0.2);
		border-top: 1px solid rgba(93, 211, 158, 0.2);
		transform: rotate(45deg);
	}
`;

const FilterItem = styled.div`
	display: flex;
	gap: 10px;
`;

const FilterGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
	gap: 20px;
	
	@media (max-width: 768px) {
		grid-template-columns: 1fr;
	}
`;

const WideFilterField = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	min-width: 250px;
	
	@media (max-width: 768px) {
		min-width: auto;
	}
`;

const FilterField = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

const FilterLabel = styled.label`
	display: block;
	font-size: 12px;
	font-weight: 600;
	color: #5DD39E;
	text-transform: uppercase;
	letter-spacing: 0.5px;
	margin-bottom: 0;
`;

const FilterButton = styled.button`
	display: flex;
	align-items: center;
	gap: 8px;
	background: transparent;
	border: 1px solid ${AppColors.MRNAVY60};
	color: #ffffff;
	padding: 10px 16px;
	border-radius: 2px;
	font-size: 13px;
	font-weight: 500;
	cursor: pointer;
	position: relative;
    height: 44px;
	outline: none;

	&:hover {
		background: ${AppColors.MRNAVY40};
        border: 1px solid ${AppColors.MRNAVY60};

	}

	&:focus {
		outline: none;
	}
`;

const Container = styled.div`
	display: flex;
	justify-content: space-between;
    padding:10px;

	@media (max-width: 768px) {
		flex-direction: column;
	}
`;

const Items = styled.div`
	display: flex;
    gap: 10px;
    
	@media (max-width: 768px) {
		margin-right: 0;
	}
`;

const FiltersContainer = styled.div`
	display: flex;
	gap: 10px;
	cursor: pointer;
	position: relative;
`;

// Styled components for Event Types dropdown
const EventTypesWrapper = styled.div`
    width: 100%;
`;

const EventTypesHeader = styled.div`
    padding: 11px 12px;
    border: 1px solid ${AppColors.MRNAVY60};
    border-radius: ${props => props.isOpen ? '2px 2px 0 0' : '2px'};
    background-color: ${AppColors.MRNAVY15};
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    color: #ffffff;
    transition: all 0.2s ease;
    height: 44px;
    
    &:hover {
        background-color: ${AppColors.MRNAVY40};
        border: 1px solid ${AppColors.MRNAVY60};
    }
`;

const SearchInput = styled.input`
    width: 100%;
    padding: 10px 12px;
    border: 1px solid ${AppColors.MRNAVY60};
    background-color: ${AppColors.MRNAVY15};
    color: #ffffff;
    font-size: 13px;
    border-radius: 0;
    outline: none;
    transition: all 0.2s ease;
    border-top: none;
        
    &::placeholder {
        color: ${AppColors.MRNAVY60};
    }

    &:focus {
        background-color: ${AppColors.MRNAVY40};
        outline: none;
    }

    &:hover {
        background-color: ${AppColors.MRNAVY40};
    }
`;

const ScrollableList = styled.div`
    max-height: 150px;
    overflow-y: auto;
    border-radius: 0 0 2px 2px;
    border: 1px solid ${AppColors.MRNAVY60};
    border-top: none;
    background-color: ${AppColors.MRNAVY15};
    
    &::-webkit-scrollbar {
        width: 8px;
    }
    
    &::-webkit-scrollbar-track {
        background: ${AppColors.MRNAVY60};
        border-radius: 4px;
    }
    
    &::-webkit-scrollbar-thumb {
        background: ${AppColors.MRNAVY40};
        border-radius: 4px;
        
        &:hover {
            background: ${AppColors.MRNAVY60};
        }
    }
    
    scrollbar-width: thin;
    scrollbar-color: ${AppColors.MRNAVY40} ${AppColors.MRNAVY60};
`;

const EventTypeItem = styled.div`
    padding: 10px 12px;
    color: #ffffff;
    font-size: 13px;
    cursor: pointer;
    transition: background 0.15s ease;
    border-bottom: 1px solid ${AppColors.MRNAVY60};
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    &:last-child {
        border-bottom: none;
    }
    
    &:hover {
        background-color: ${AppColors.MRNAVY40};
    }
`;

export { Container, Items, TickerInfo, StockChartContainer, StockSelect, FilterContainer, FilterItem, FiltersContainer, FilterGrid, FilterField, FilterLabel, FilterButton, WideFilterField, EventTypesWrapper, EventTypesHeader, SearchInput, ScrollableList, EventTypeItem };